<div class="nav-bar">
  <div class="nav-bar-holder">
    <div class="logo">
      <a href="">
        <img src="assets/img/logo.png" alt="logo" />
      </a>
    </div>

    <div class="menu">
      <div class="dropdown">
        <button class="dropbtn">
          <a href="why-huiospay">Why Huiospay</a>
        </button>
      </div>

      <div class="dropdown">
        <button class="dropbtn">
          Developer
          <app-font-icon
            iconType="remix"
            iconName="arrow-down-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
        </button>
        <div class="dropdown-content">
          <a href="developer-section">Overview</a>
          <a href="developer-section">Integration</a>
          <!-- <a href="https://docs.google.com/document/d/1ZYwPrnXr7mgeahGQezqG63uP0lNOLwCM8SzLLbgTYGo/edit?tab=t.0#heading=h.6xcq3fjg48li" target="_blank">API Documentation</a> -->
        </div>
      </div>

      <div class="dropdown">
        <button class="dropbtn">
          Company
          <app-font-icon
            iconType="remix"
            iconName="arrow-down-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
        </button>
        <div class="dropdown-content">
          <a href="about-us">About Us</a>
          <a href="training-and-development">Training & Development</a>
          <a href="careers">Careers</a>
          <a href="customer-review">Customer Review</a>
          <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16">Payment Gateway</a>
          <a href="https://payslate.com.ng" target="_blank">Payslate</a>
          <a href="https://user.payslate.com.ng" target="_blank">Payslate for user</a>
          <a href="https://organization.payslate.com.ng/" target="_blank">Payslate for organization</a>
        </div>
      </div>

      <div class="dropdown">
        <button class="dropbtn">
          Support
          <app-font-icon
            iconType="remix"
            iconName="arrow-down-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
        </button>
        <div class="dropdown-content">
          <a href="contact-us">Contact Us</a>
          <a href="faqs">FAQs</a>
          <a href="quick-help">Quick Help</a>
        </div>
      </div>
    </div>

    <div class="menu-action">
      <div class="action">
        <div class="button-row">
          <button class="btn">
            <!-- https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16  -->
            <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16"
            target="_blank" style="text-decoration: none">
              Create merchant account
            </a>
          </button>
        </div>
                  <!-- href="https://huiospay-payment-gateway.netlify.app/" -->

        <!-- <div class="icon">
          <a
            href="/become-agent"
            target="_blank"
            rel="noopener noreferrer"
          >
            <app-font-icon
              iconType="remix"
              iconName="user-fill"
              iconSize="custom"
              iconColor="#fff"
            >
            </app-font-icon>
          </a>
        </div> -->
      </div>
    </div>

    <section class="top-nav">
      <input id="menu-toggle" (click)="switchCase(0)" type="checkbox" />
      <label class="menu-button-container" for="menu-toggle">
        <div class="menu-button"></div>
      </label>
      <ul class="menu-a">
        <li>
          <a href="why-huiospay">Why Huiospay</a>
        </li>
        <li (click)="switchCase(1)">
          Developer
          <app-font-icon
            iconType="remix"
            iconName="arrow-right-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
          <div class="mobile-dropdown-content" *ngIf="result === 'Case 1'">
            <a href="developer-section">Overview</a>
            <a href="developer-section#seamless">Integration</a>
            <a href="developer-section#documentation">Documentation</a>
          </div>
        </li>
        <li (click)="switchCase(2)">
          Company
          <app-font-icon
            iconType="remix"
            iconName="arrow-right-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
          <div class="mobile-dropdown-content" *ngIf="result === 'Case 2'">
            <a href="about-us">About Us</a>
            <a href="training-and-development">Training & Development</a>
            <a href="careers">Careers</a>
            <a href="customer-review">Customer Review</a>
            <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" target="_blank">Payment Gateway</a>
            <a href="https://user.payslate.com.ng" target="_blank">Payslate</a>
            <a href="https://organization.payslate.com.ng/" target="_blank">Payslate for organization</a>
          </div>
        </li>
        <li (click)="switchCase(3)">
          Support
          <app-font-icon
            iconType="remix"
            iconName="arrow-right-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
          <div class="mobile-dropdown-content" *ngIf="result === 'Case 3'">
            <a href="contact-us">Contact Us</a>
            <a href="faqs">FAQs</a>
            <a href="quick-help">Quick Help</a>
          </div>
        </li>
        <li (click)="switchCase(4)">
          Become Agent
          <app-font-icon
            iconType="remix"
            iconName="arrow-right-s-line"
            iconSize="custom"
            iconColor="#fff"
          >
          </app-font-icon>
          <div class="mobile-dropdown-content" *ngIf="result === 'Case 4'">
            <a href="become-agent">Become POS agent</a>
            <a href="become-merchant">Become POS merchant</a>
          </div>
        </li>
      </ul>
    </section>
  </div>
</div>
